module.exports = __webpack_public_path__ + "assets/img/奖品自动发放.f210ae44.jpg";